import { onPageLoad } from '../modules/page_lifecycle.js';

onPageLoad(() => {
  const supportsSvg =
    !!document.createElementNS &&
    !!document.createElementNS('http://www.w3.org/2000/svg', 'svg').createSVGRect;

  if (supportsSvg) return;

  document.querySelectorAll('img[src$=".svg"][data-fallback]').forEach((img) => {
    const fallback = img.dataset.fallback;
    if (fallback) img.src = fallback;
  });
});
